var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 76,
    viewBox: "0 0 84 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3478 0.367432H8.45375C4.30467 0.367432 0.909973 3.76213 0.909973 7.91121V53.1739C0.909973 57.323 4.30467 60.7177 8.45375 60.7177H34.857V68.2614H27.3132V75.8052H57.4883V68.2614H49.9445V60.7177H76.3478C80.4968 60.7177 83.8915 57.323 83.8915 53.1739V7.91121C83.8915 3.76213 80.4968 0.367432 76.3478 0.367432ZM76.3478 53.1739H8.45375V7.91121H76.3478V53.1739Z",
    fill: "url(#paint0_linear_1_75)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_75",
    x1: 42.4008,
    y1: 0.367432,
    x2: 42.4008,
    y2: 75.8052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0D2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopWindows);
export default __webpack_public_path__ + "static/media/desktop_windows.4301b13389213ef41e627dc58cc64638.svg";
export { ForwardRef as ReactComponent };